import React from 'react';
import styles from './Home.module.scss';
import photo from '../assets/home-example.png';

function Home() {
    return (
        <div className={styles.container}>
            <div className={styles.inner}>
                <div className={styles.photoWrapper}>
                    <img className={styles.photo} src={photo} alt="homePhoto" />
                </div>
                <div className={styles.textContainer}>
                    <div className={styles.birthday}>1999.03.22</div>
                    <div className={styles.context}>
                        어느 생그러운 봄날 우리에게 다가온 너.
                    </div>
                    <div className={styles.context}>
                        언제나처럼 푸르른 모습으로 내 옆에 있어줘서 고마워.
                    </div>
                    <div className={styles.context}>
                        생일 축하해 주하야.
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Home;
